import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import { CheckNull, PriceFormat, formatDate, numberToWords, FormatValueDecimal } from "../../../utils/Validate";
import { quoteSummaryStyles } from "./QuotePDFSummaryStyleSheet";
import { FooterComponent } from "./FooterComponent";
import { HeaderComponent } from "./HeaderComponent"
import { useEffect, useState } from "react";
import FetchData, { GetListAsync, GetOne } from "../../../providers/dataProvider";
import urls from "../../../constants";
import { TermsAndConditionPDF } from "./termsAndConditions";
import { TermsAndConditionFooterComponent } from "./termsAndConditionsFooter"
import { TermsAndConditionHeaderComponent } from "./termsAndConditionsHeader";
import { CurrencyConvertion } from "../../../utils/Validate";

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf' }
  ]
});
export const QuotePDFSummary = ({distributorList, values, currencyDetail }) => {
  const [quotePDFDetails, setQuotePDFDetails] = useState(null);
  let totalDdp = 0;

  const { data: customerList } = FetchData("Customer");
  const { data: inquiryList } = FetchData("inquiry");
  const { data: assignedEngineerList } = FetchData("userprofile");
  const { data: deliveryTermsList } = FetchData("deliveryterms");
  const { data: paymentTermsList } = FetchData("paymentterms");
  const { data: projectData } = FetchData("project");
  const { data: countryList } = FetchData("country");

  const customerObj = customerList?.find((ob) => ob?.id == quotePDFDetails?.data?.customerId)
  const enquiryObj = inquiryList?.find((ob) => ob?.id == quotePDFDetails?.data?.enquiryId)
  const salesEngObj = assignedEngineerList?.find((ob) => ob?.identityId == quotePDFDetails?.data?.salesEngineerId)
  const projectObj = projectData?.find((ob) => ob?.id == quotePDFDetails?.data?.projectId)

  useEffect(() => {
    if (values?.id) {
      GetOne("quotation", { id: values?.id }, setQuotePDFDetails);
    }
  }, [values?.id]);

  return (
    <Document>
      <Page size="A4" style={quoteSummaryStyles.page}>
        <HeaderComponent distributorList={distributorList} />
        <View style={quoteSummaryStyles.table}>
          {/* Table Header */}
          <View style={quoteSummaryStyles.tableRow}>
            <View
              style={[
                quoteSummaryStyles.tableCol,
                { borderRightWidth: 1, borderRightColor: "#63707E" },
              ]}
            >
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Customer</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{customerObj?.customerName}</Text>
                </View>
              </View>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Address</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{quotePDFDetails?.data?.customerAddress}</Text>
                </View>
              </View>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Contact Person</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{quotePDFDetails?.data?.contactPerson}</Text>
                </View>
              </View>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Contact #</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{quotePDFDetails?.data?.phone}</Text>
                </View>
              </View>
            </View>
            <View style={quoteSummaryStyles.tableCol}>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Quote Ref</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{quotePDFDetails?.data?.quoteReference}</Text>
                </View>
              </View>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Date</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{formatDate(quotePDFDetails?.data?.createdAt, "")}</Text>
                </View>
              </View>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Customer Email</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{quotePDFDetails?.data?.emailAddress}</Text>
                </View>
              </View>
              <View style={quoteSummaryStyles.tableRow}>
                <View style={quoteSummaryStyles.tableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadCell}>Sales Eng</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableCol}>
                  <Text style={quoteSummaryStyles.tableCell}>{salesEngObj?.firstName + " " + salesEngObj?.lastName}</Text>
                </View>
              </View>
            </View>
          </View>
          <View style={quoteSummaryStyles.projectTableRow}>
            <View style={quoteSummaryStyles.tableProjectCol}>
              <View style={quoteSummaryStyles.tableProjectRow}>
                <View style={quoteSummaryStyles.projectTableHeadCol}>
                  <Text style={quoteSummaryStyles.tableHeadProjectCell}>Project</Text>
                </View>
                <View>
                  <Text style={quoteSummaryStyles.tableColonProjectCell}>
                    :</Text>
                </View>
                <View style={quoteSummaryStyles.tableProjectCol}>
                  <Text style={quoteSummaryStyles.tableProjectCell}>{projectObj?.projectName}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        <Text style={quoteSummaryStyles.proposalText}>
          Dear Sir/Madam, {"\n"}We thank you for your enquiry and
          are pleased to submit our proposal as follows:
        </Text>
        <View style={quoteSummaryStyles.modelProductListDetailTable}>
          <View style={quoteSummaryStyles.modelProductListDetailRow}>
            <View style={quoteSummaryStyles.modelProductListDetailHeadColumn}>
              <Text style={quoteSummaryStyles.modelProductListDetailTableHeadCell}>#</Text>
            </View>
            <View style={quoteSummaryStyles.modelProductListDetailTagRefHeadColumn}>
              <Text style={[quoteSummaryStyles.modelProductListDetailTableHeadCell, { textAlign: "left" }]}>
                Product Group
              </Text>
            </View>
            <View style={quoteSummaryStyles.modelProductListDetailSizeHeadColumn}>
              <Text style={quoteSummaryStyles.modelProductListDetailTableHeadCell}>
                Model
              </Text>
            </View>
            <View style={quoteSummaryStyles.modelProductListDetailQtyHeadColumn}>
              <Text style={quoteSummaryStyles.modelProductListDetailTableHeadCell}>Qty</Text>
            </View>
            <View style={quoteSummaryStyles.modelProductListDetailUnitHeadColumn}>
              <Text style={quoteSummaryStyles.modelProductListDetailTableHeadCell}>
                Total Price ({currencyDetail?.shortCode})
              </Text>
            </View>
          </View>
          {
            quotePDFDetails?.data?.products?.map((item, index) => {
              totalDdp = ((totalDdp || 0) * 1) + (item?.totalDdp)
              return (
                <View style={quoteSummaryStyles.modelProductListDetailRow}>
                  <View style={quoteSummaryStyles.modelProductListDetailsColumn}>
                    <Text style={quoteSummaryStyles.modelProductListDetailTableCell}>{index + 1}</Text>
                  </View>
                  <View style={quoteSummaryStyles.modelProductListDetailTagRefColumn}>
                    <Text style={[quoteSummaryStyles.modelProductListDetailTableCell, { textAlign: "left" }]}>
                      {item?.groupName}
                    </Text>
                  </View>
                  <View style={quoteSummaryStyles.modelProductListDetailModelColumn}>
                    <Text style={quoteSummaryStyles.modelProductListDetailTableCell}>
                      {item?.productName}
                    </Text>
                  </View>
                  <View style={quoteSummaryStyles.modelProductListDetailQtyColumn}>
                    <Text style={quoteSummaryStyles.modelProductListDetailTableCell}>{item?.quantity}</Text>
                  </View>
                  <View style={quoteSummaryStyles.modelProductListDetailTotalColumn}>
                    <Text style={quoteSummaryStyles.modelProductListDetailTableCell}>
                      {FormatValueDecimal(CurrencyConvertion(item?.totalDdp, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                    </Text>
                  </View>
                </View>
              )
            })
          }
        </View>
        <View style={quoteSummaryStyles.detailsTable}>
          {quotePDFDetails?.data?.netPrice > 0 && (<View style={quoteSummaryStyles.detailsTableRow}>
            <View style={quoteSummaryStyles.detailsTableColumn}>
              <Text style={[quoteSummaryStyles.detailsTableCell, { paddingTop: "5px" }]}>Net Price :</Text>
            </View>
            <View style={quoteSummaryStyles.detailsQarTableColumn}>
              <Text style={[quoteSummaryStyles.detailsQarTableCell, { paddingTop: "5px" }]}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteSummaryStyles.detailsPriceTableColumn}>
              <Text style={[quoteSummaryStyles.detailsPriceTableCell, { paddingTop: "5px" }]}>{FormatValueDecimal(CurrencyConvertion(totalDdp, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)}
          {/* {quotePDFDetails?.data?.specialCharges > 0 && (<View style={quoteSummaryStyles.detailsTableRow}>
            <View style={quoteSummaryStyles.detailsTableColumn}>
              <Text style={quoteSummaryStyles.detailsTableCell}>Special Colour Charges:</Text>
            </View>
            <View style={quoteSummaryStyles.detailsQarTableColumn}>
              <Text style={quoteSummaryStyles.detailsQarTableCell}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteSummaryStyles.detailsPriceTableColumn}>
              <Text style={quoteSummaryStyles.detailsPriceTableCell}>{FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.specialCharges, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)} */}
          {(quotePDFDetails?.data?.tax > 0 || quotePDFDetails?.data.taxPercentage > 0) && (<View style={quoteSummaryStyles.detailsTableRow}>
            <View style={quoteSummaryStyles.detailsTableColumn}>
              <Text style={quoteSummaryStyles.detailsTableCell}>Taxes / VAT {quotePDFDetails?.data?.tax > 0 ? "" : "@ " + quotePDFDetails?.data.taxPercentage + "%"} :</Text>
            </View>
            <View style={quoteSummaryStyles.detailsQarTableColumn}>
              <Text style={quoteSummaryStyles.detailsQarTableCell}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteSummaryStyles.detailsPriceTableColumn}>
              <Text style={quoteSummaryStyles.detailsPriceTableCell}>{quotePDFDetails?.data?.tax > 0 ? FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.tax, quotePDFDetails?.data?.conversionRate, currencyDetail)) :
                FormatValueDecimal(CurrencyConvertion(((((values?.totalLandedCost * 1) / (1 - (values?.salesMarginPercentage / 100))) * 1) * ((values?.taxPercentage * 1) / 100)), quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)}
          {/* {quotePDFDetails?.data?.totalSellingPrice > 0 && (<View style={quoteSummaryStyles.detailsTableRow}>
            <View style={quoteSummaryStyles.detailsTableColumn}>
              <Text style={quoteSummaryStyles.detailsTableCell}>Total Selling Price :</Text>
            </View>
            <View style={quoteSummaryStyles.detailsQarTableColumn}>
              <Text style={quoteSummaryStyles.detailsQarTableCell}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteSummaryStyles.detailsPriceTableColumn}>
              <Text style={quoteSummaryStyles.detailsPriceTableCell}>{FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.totalSellingPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)} */}
          {quotePDFDetails?.data?.grandTotal > 0 && (<View style={[quoteSummaryStyles.totalDetailsTableRow, { borderTop: "1px solid #63707E" }]}>
            <View style={quoteSummaryStyles.totalDetailsTableColumn}>
              <Text style={[quoteSummaryStyles.totalDetailsTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}></Text>
            </View>
            <View style={quoteSummaryStyles.totalDetailsPriceTableColumn}>
              <Text style={[quoteSummaryStyles.totalDetailsPriceTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}></Text>
            </View>
            <View style={quoteSummaryStyles.grandTotalDetailsTableColumn}>
              <Text style={[quoteSummaryStyles.totalDetailsTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>Grand Total :</Text>
            </View>
            <View style={quoteSummaryStyles.grandTotalDetailsQarTableColumn}>
              <Text style={[quoteSummaryStyles.detailsQarTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteSummaryStyles.grandTotalDetailsPriceTableColumn}>
              <Text style={[quoteSummaryStyles.detailsPriceTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>{FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)}
          {quotePDFDetails?.data?.grandTotal > 0 && (<View style={[quoteSummaryStyles.totalDetailsTableRow, { borderTop: "1px solid #63707E" }]}>
            <View style={quoteSummaryStyles.totalDetailsTableColumn}>
              <Text style={[quoteSummaryStyles.totalDetailsTableCell, { paddingLeft: "5px" }]}>TOTAL (in words) :</Text>
            </View>
            <View style={quoteSummaryStyles.totalDetailsFullPriceTableColumn}>
              <Text style={[quoteSummaryStyles.totalDetailsPriceTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>{numberToWords(CurrencyConvertion(quotePDFDetails?.data?.grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail), currencyDetail)}</Text>
            </View>
          </View>)}
        </View>
        <View style={quoteSummaryStyles.termsandConditionTable}>
          <View style={quoteSummaryStyles.termsandConditionTableRow}>
            <View style={[{ marginBottom: "10px" }]}>
              <Text
                style={quoteSummaryStyles.termsandConditionTableHeadingCell}>
                Terms & Conditions
              </Text>
            </View>
          </View>
          <View style={quoteSummaryStyles.termsandConditionTableRow}>
            <View style={quoteSummaryStyles.termsandConditionTableColumn}>
              <Text style={quoteSummaryStyles.termsandConditionTableHeadCell}>
                Payment Terms</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableCell}>
                {quotePDFDetails?.data?.paymentTerms || paymentTermsList?.find(item => item?.id === quotePDFDetails?.data?.paymentTermId)?.paymentDescription}
              </Text>
            </View>
          </View>
          <View style={quoteSummaryStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableHeadCell}>
                Delivery Terms</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableCell}>
                {quotePDFDetails?.data?.deliveryTerms || deliveryTermsList?.find(item => item?.id === quotePDFDetails?.data?.deliveryTermId)?.deliveryDescription
                  || quotePDFDetails?.data?.destination}
                {countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name
                  && (countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name)}
              </Text>
            </View>
          </View>
          <View style={quoteSummaryStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableHeadCell}>
                Delivery Period</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableCell}>
                As per the project requirement
              </Text>
            </View>
          </View>
          <View style={quoteSummaryStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableHeadCell}>
                Validity</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableCell}>
                {quotePDFDetails?.data?.quoteValidity} days from the date hereof and thereafter subject to our written confirmation.
              </Text>
            </View>
          </View>
          <View style={quoteSummaryStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableHeadCell}>
                Warranty</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteSummaryStyles.termsandConditionTableCell}>
                Goods manufactured by Jersey Manufacturing carry a standard warranty of 12 months from the date of
                supply, against all manufacturing defects, subject to our warranty policy - (can be provided on request).
              </Text>
            </View>
          </View>
          <View style={[quoteSummaryStyles.declarationTable, { marginTop: "20px" }]}>
            <View style={quoteSummaryStyles.declarationTableRow}>
              <View>
                <Text style={quoteSummaryStyles.italicFooterText}>
                  We once again thank you for the opportunity to quote for your
                  requirement. Please feel free to contact us in case of any
                  clarification.Thanking you and assuring you our best attention and services at all times.
                </Text>
              </View>
            </View>
            <View style={quoteSummaryStyles.declarationTableRow}>
              <View>
                <Text style={quoteSummaryStyles.boldFooterText}>
                  For, Jersey Manufacturing for Airconditioning Products
                </Text>
              </View>
            </View>
            <View style={[quoteSummaryStyles.signatureTableRow, { marginTop: "20px" }]}>
              <View style={[quoteSummaryStyles.signatureTableColumn, { width: "50%" }]}>
                <Text
                  style={[
                    quoteSummaryStyles.signatureTableCell,
                    {
                      paddingLeft: "20px",
                      textAlign: "left",
                      fontSize: "10px",
                    },
                  ]}
                >
                  Sales Engineer{"\n"}
                </Text>
              </View>
              <View style={[quoteSummaryStyles.signatureTableColumn, { width: "50%" }]}>
                <Text
                  style={[
                    quoteSummaryStyles.signatureTableCell,
                    {
                      paddingRight: "20px",
                      textAlign: "right",
                      fontSize: "10px",
                    },
                  ]}
                >
                  Divisional manager
                </Text>
              </View>
            </View>
          </View>
        </View>
        <FooterComponent values={quotePDFDetails?.data} distributorList={distributorList} />
      </Page>
      <Page size="A4" style={[quoteSummaryStyles.page, { paddingBottom: "100px" }]}>
        <TermsAndConditionHeaderComponent distributorList={distributorList} />
        <TermsAndConditionPDF />
        <TermsAndConditionFooterComponent values={quotePDFDetails?.data} distributorList={distributorList} />
      </Page>
    </Document>
  );
};
